import { Box, Card, Chip, Stack, Typography} from "@mui/material";
import { useEffect, useState } from "react";
import { apiOperation, headers } from "../../services/api";
import { Pedido } from "../../models/notouch/pedido";
import { Paginacao, Resultado } from "../../models/base/basic";
import { ETipoStatusPedido } from "../../models/enums/TipoStatusPedido";

export const Subscription = ({ showLoading, hideLoading, showError }: any) => {
  const [subscriptionList, setSubscriptionList] = useState<Pedido[]>([]);

  const getSubscriptionHistory = async () => {
      showLoading("Carregando assinaturas...");
      try {
        const config = {
          headers: headers(),
        };
        let urlString = `notouch/pedido/assinatura`;
  
        const { data } = await apiOperation.get<Resultado<Pedido[]>>(urlString, config);
  
        if (!data.erro) {
          setSubscriptionList([...data.valor]);
          hideLoading();
        } else {
            throw new Error(`${data.erros?.join("|")}`);
        }
      } catch (error: any) {
        showError(
          "Erro ao carregar assinaturas",
          `Caso o problema continue informe o seguinte erro: ${error?.response?.status}-${error?.response?.statusText}`
        );
        hideLoading();
      }
    };

  const formatStatusPedido = (value: any) => {
        var status = ETipoStatusPedido[value as keyof typeof ETipoStatusPedido];
        var css = {
          backgroundColor: "var(--action-disabled-surface)",
          borderRadius: "15px",
          width: "fit-content",
          padding: "inherit",
          color: "var(--text-primary)",
          margin: "auto",
        };
    
        switch (status) {
          case ETipoStatusPedido.CONFIRMADO:
          case ETipoStatusPedido.FINALIZADO:
            return { ...css, backgroundColor: "var(--success-surface)", color: "var(--text-primary)" };
          case ETipoStatusPedido.CANCELADO:
            return { ...css, backgroundColor: "var(--error-surface)", color: "var(--text-primary)" };
          case ETipoStatusPedido.CRIADO:
            return { ...css, backgroundColor: "var(--warning-surface)", color: "var(--text-primary)" };
          default:
            return { ...css };
        }
      }
  
  useEffect(() => {
    getSubscriptionHistory();
  }, []);

  return (
    <>
      <Box sx={{paddingBlockEnd: 3, textAlign: "center", fontSize: "20px", color: "var(--text-secondary)"}}>
          <h3>Minhas Assinaturas</h3>
      </Box>
      <Stack spacing={3}>
        {subscriptionList.map((item) => (
          <Card key={item.id} sx={{boxShadow: 2, padding: 2, backgroundColor: "var(--surface-sunken)" }}>
            <Box sx={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
              <Box sx={{display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "space-evenly", minWidth: 310, width: "40%", height: 310, padding: 3, borderRadius: 3, boxShadow: 3, background: "var(--surface-raised)"}}>
                <Typography variant="h4" component="div" sx={{color: "var(--text-primary)"}}>
                  {item.produtoNome}
                </Typography>
                <Typography component="div" variant="h6" sx={{color: "var(--text-primary)"}}>
                  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.produtoPreco ?? 0)} / Mês
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{color: "var(--text-secondary)"}}>
                  {item.produtoDescricao}
                </Typography>
              </Box>
              <Box sx={{width: "60%", height: 310, padding: "0px 24px 24px 24px"}}>
                <Box>
                  <Typography variant="h6" component="div" sx={{color: "var(--text-primary)", textAlign: "right"}}>
                  {item.pedidoNumero}
                </Typography>
                  <Typography component="div" variant="h5" sx={{borderBottom: "2px solid var(--border-default)" , paddingBottom: 1, color: "var(--text-primary)"}}>
                    Status
                  </Typography>
                  <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBlock: 2}}>
                    <Typography component="div" variant="subtitle2" sx={{color: "var(--text-secondary)"}}>
                      Situação do plano
                    </Typography>
                    <Typography component="div" variant="body2">
                      <Chip 
                        label={ETipoStatusPedido[item.pedidoStatus as keyof typeof ETipoStatusPedido] ?? "N/D"} 
                        sx={formatStatusPedido(item.pedidoStatus)}
                      />
                    </Typography>
                  </Box>  
                  <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBlock: 2}}>
                    <Typography component="div" variant="subtitle2" sx={{color: "var(--text-secondary)"}}>
                      Consumo
                    </Typography>
                    <Typography component="div" variant="body2">
                      {item.pedidoRecorrencia * item.produtoValor} / {item.produtoVigencia * item.produtoValor} Créditos
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography component="div" variant="h5" sx={{borderBottom: "2px solid var(--border-default)" , paddingBottom: 1, color: "var(--text-primary)"}}>
                    Pagamento
                  </Typography>
                  <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBlock: 2}}>
                    <Typography component="div" variant="subtitle2" sx={{color: "var(--text-secondary)"}}>
                      Vigência
                    </Typography>
                    <Typography component="div" variant="body2">
                      {item.produtoAssinatura ? `${item.produtoVigencia} Meses` : "Sem Recorrência"}
                    </Typography>
                  </Box>
                  <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBlock: 2}}>
                    <Typography component="div" variant="subtitle2" sx={{color: "var(--text-secondary)"}}>
                      Renovação
                    </Typography>
                    <Typography component="div" variant="body2">
                        {item.pagamentoData
                          ? (() => {
                              const data = new Date(item.pagamentoData);
                              // Adiciona o número de meses da vigência
                              data.setMonth(data.getMonth() + (item.produtoVigencia ?? 0));
                              return data.toLocaleDateString('pt-BR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                              });
                            })()
                          : "N/D"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Card>
        ))}
        {subscriptionList.length === 0 && (
          <Card sx={{boxShadow: 2, padding: 2, backgroundColor: "var(--surface-sunken)"}}>
            <Box sx={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
              <Typography variant="h5" component="div" sx={{color: "var(--text-secondary)"}}>
                Você não possui assinaturas ativas.
              </Typography>
            </Box>
          </Card>
        )}
      </Stack>
    </>
  );
};